import React from "react";

export type PathologyReceiptData = {
  clinicName?: string;
  clinicTagline?: string;
  clinicAddress?: string;
  clinicPhone?: string;
  clinicEmail?: string;
  billNumber?: string;
  labId?: number;
  patientName?: string;
  refBy?: string;
  billDate?: string;
  ageSex?: string;
  centre?: string;
  investigations?: Array<{ name: string; amount: number }>;
  testAmount?: number;
  payableAmount?: number;
  receivedAmount?: number;
  amountInWords?: string;
};

const PathologyReceipt: React.FC<{ data: PathologyReceiptData }> = ({ data }) => {
  return (
    <div className="max-w-[800px] mx-auto border border-gray-800 p-6 bg-white">
      <div className="flex justify-between items-start mb-4">
        <div>
          <div className="text-lg font-bold">
            {data.clinicName ?? "Clinic"} {data.clinicTagline ?? "PATHOLOGY LABORATORY"}
          </div>
        </div>
        <div className="text-right text-xs">
          {data.clinicAddress && <div>{data.clinicAddress}</div>}
          {data.clinicPhone && <div>Contact No: {data.clinicPhone}</div>}
          {data.clinicEmail && <div>Email Id: {data.clinicEmail}</div>}
        </div>
      </div>

      <div className="text-center text-base font-bold underline mb-4">
        RECEIPT / BILL
      </div>

      <div className="grid grid-cols-2 gap-2 text-sm mb-4">
        <div><strong>Bill No.:</strong> {data.billNumber ?? "-"}</div>
        <div><strong>Lab ID:</strong> {data.labId ?? "-"}</div>
        <div><strong>Patient:</strong> {data.patientName ?? "-"}</div>
        <div><strong>Ref. By:</strong> {data.refBy ?? "-"}</div>
        <div><strong>Date:</strong> {data.billDate ?? "-"}</div>
        <div><strong>Age/Sex:</strong> {data.ageSex ?? "-"}</div>
        <div><strong>Centre:</strong> {data.centre ?? "-"}</div>
      </div>

      <div className="mb-4">
        <div className="font-semibold text-sm mb-2">INVESTIGATIONS</div>
        <table className="w-full border-collapse border border-gray-800 text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border border-gray-800 p-2 text-left">Investigation</th>
              <th className="border border-gray-800 p-2 w-24 text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {(data.investigations ?? []).map((inv, idx) => (
              <tr key={idx}>
                <td className="border border-gray-800 p-2">{inv.name}</td>
                <td className="border border-gray-800 p-2 text-right">
                  {(inv.amount ?? 0).toFixed(2)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="space-y-1 text-sm mb-2">
        <div><strong>Test Amount:</strong> {(data.testAmount ?? 0).toFixed(2)}</div>
        <div><strong>Payable Amount:</strong> {(data.payableAmount ?? 0).toFixed(2)}</div>
        <div><strong>Received:</strong> {(data.receivedAmount ?? 0).toFixed(2)}</div>
      </div>

      <div className="text-sm italic">
        Amount of: {data.amountInWords ?? ""}
      </div>
    </div>
  );
};

export default PathologyReceipt;
